import React from 'react'

import FiveConsequencesTable from './five_consequences_table';
import ConsequenceCell from '../consequence_cell';
import { getText } from '../../../helpers';

import '../consequence_table.css'

export default class SixConsequencesTable extends FiveConsequencesTable {
  constructor(props){
    super(props);

    const { row, isNewConsequence } = props;
    this.state = {
      row,
      rowsCount: 6,
      notClickableColumns: ["consequence_level", "consequence_factor", "impact_categories"]
    };

    const datafield_prefix = isNewConsequence ? "6x6_new_" : "6x6_";

    this.consequences = [
      {
        dataField: "consequence_level",
        text: getText("Consequence Level"),
        classes: "consequences-table-cell centered not-clickable",
        headerClasses: "consequences-table-header",
        headerAttrs: { 'rowSpan': "2" },
        expandable: false,
        rows: [ 
          `6 - ${getText("Extreme")}`,
          `5 - ${getText("Very High")}`,
          `4 - ${getText("High")}`,
          `3 - ${getText("Significant")}`,
          `2 - ${getText("Moderate")}`,
          `1 - ${getText("Minor")}`
        ]
      },
      {
        dataField: "impact_categories",
        text: getText("Impact Categories"),
        classes: "",
        headerClasses: "consequences-table-header",
        headerAttrs: { "colSpan": "7" },
        hidden: true,
        expandable: false,
        rows: []
      },
      {
        dataField: datafield_prefix + "financial",
        text: getText("Financial"),
        classes: "consequences-table-cell centered",
        headerClasses: "consequences-table-header",
        expandable: false,
        rows: [ 
          getText(">$500M"),
          getText("$250M-$500M"),
          getText("$100M-$250M"),
          getText("$25M-$100M"),
          getText("$1M-$25M"),
          getText("< $1M"),
        ]
      },
      {
        dataField: datafield_prefix + "safety",
        text: getText("Safety"),
        classes: "consequences-table-cell",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ 
          getText("Mass fatality or serious disabling injury to six or more people"),
          getText("Single to multiple occurrences (five or less) of fatalities, irreversible health effects or disabling illness"),
          getText("Life altering injury with moderate to high reduction in quality of life"),
          getText("Medium term reversible injury with low to moderate reduction in quality of life, typically necessitating time off work."),
          getText("Short to medium-medium term reversible injury, typically requiring medical treatment or restricted work."),
          getText("Low-level, short-term symptoms, typically requiring basic first aid."),
        ]
      },
      {
        dataField: datafield_prefix + "hygiene",
        text: getText("Hygiene"),
        classes: "consequences-table-cell",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ 
          getText("Mass fatality or serious disabling illness to six or more people"),
          getText("Single to multiple occurrences (five or less) of fatalities, irreversible health effects or disabling illness"),
          getText("Life altering illness with moderate to high reduction in quality of life"),
          getText("Medium term reversible illness with low to moderate reduction in quality of life, typically necessitating time off work."),
          getText("Short to medium-medium term reversible illness, typically requiring medical treatment or restricted work."),
          getText("Low-level, short-term symptoms, typically requiring basic first aid."),
        ]
      },
      {
        dataField: datafield_prefix + "reputation",
        text: getText("Reputation"),
        classes: "consequences-table-cell",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ 
          getText("Global media attention; widespread stakeholder outrage; major impact to numerous key stakeholder relationships."),
          getText("International media attention; widespread stakeholder concern; serious impact to relationships with key stakeholders."),
          getText("National media attention; medium impact to relationship with key stakeholders."),
          getText("Regional media attention; medium impact to relationship with small number of stakeholders."),
          getText("Local media attention; minor impact to relationship with a small number of stakeholders"),
          getText("No media attention; minimal impact on relationship with stakeholders."),
        ]
      },
      {
        dataField: datafield_prefix + "environmental",
        text: getText("Environment"),
        classes: "consequences-table-cell",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ 
          getText("Permanent environmental impact to an extensive area resulting in complete loss that would be deemed irremediable."),
          getText("Long-term environmental impact to an extensive area that is irreversible but is remediable with substantial efforts."),
          getText("Medium-term environmental impact to a large area that is reversible or remediable."),
          getText("Medium-term environmental impact that is noticeable and measurable to a localized area that is reversible or remediable."),
          getText("Short-term environmental impact that is noticeable and measurable to a localized area that is reversible or remediable."),
          getText("Short-term or negligible environmental impact to a localized area that is reversible or remediable"),
        ]
      },
      {
        dataField: datafield_prefix + "legal",
        text: getText("Legal"),
        classes: "consequences-table-cell",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ 
          getText("Forced closure of an operation/cessation of project. Serious criminal charges and restricted business activities."),
          getText("Material civil litigation, criminal charges, material fines, penalties and/or sanctions."),
          getText("High consequence civil litigation, alternative dispute resolution, and/or administrative proceedings. Fines, penalties and/or sanctions."),
          getText("Litigation, alternative dispute resolution, and/or administrative proceedings with modest impact."),
          getText("Several minor and potentially related legal, regulatory, or compliance matters."),
          getText("Minor legal matter involving at least one external stakeholder."),
        ]
      },
      {
        dataField: datafield_prefix + "community",
        text: getText("Community"),
        classes: "consequences-table-cell",
        headerClasses: "consequences-table-header",
        expandable: true,
        rows: [ 
          getText("Permanent impact to a community that is irreversible and would be deemed irremediable"),
          getText("Long-term impact to a community that is irreversible but is remediable with substantial efforts."),
          getText("Medium-term impact to a large number of individuals that is reversible or remediable"),
          getText("Medium-term impact to a small number of individuals or households that is reversible or remediable"),
          getText("Short-term impact to a small number of individuals or households that is reversible or remediable"),
          getText("Short-term impact to a single individual or household that is reversible or remediable"),
        ]
      },
      {
        dataField: "consequence_factor",
        text: getText("Consequence Factor"),
        classes: "consequences-table-cell centered not-clickable",
        headerClasses: "consequences-table-header",
        headerAttrs: { "rowSpan": "2" },
        expandable: false,
        rows: [ 1000, 300, 100, 30, 10, 3 ]
      }
    ]

  }

  getTargetValue = (rowIndex) => {
    return 6 - rowIndex
  }

  ConsequencesTable = () => {
    const { notClickableColumns } = this.state;
    const tableColumns = this.tableColumns();
    const tableRows = this.tableRows();

    return (
      <div className="consequences-table-container">
        <table className="consequences-table">
          <thead>
            <tr>
              {
                tableColumns.map((column, i)=>{
                  if (!notClickableColumns.includes(column.dataField)) return;
                  const { text, headerClasses, headerAttrs } = column;
                  return <th key={i} {...headerAttrs} className={headerClasses}>{text}</th>
                })
              }
            </tr>
            <tr>
              {
                tableColumns.map((column, i)=>{
                  if (notClickableColumns.includes(column.dataField)) return;
                  const { text, headerClasses } = column;
                  return <th key={i} className={headerClasses}>{text}</th>
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              tableRows.map((row, rowIndex)=>{
                return (
                  <tr key={rowIndex}>
                    {
                      tableColumns.map((column, colIndex)=>{
                        let { dataField, classes, hidden=false, expandable } = column;

                        if (hidden) return;
        
                        const text = row[dataField];
                        classes = this.getCellClass(dataField, rowIndex, classes);

                        return (
                          <td key={colIndex} className={classes} column={dataField} title={text} onClick={(e)=>this.onCellClick(e, row, rowIndex)}>
                            <ConsequenceCell {...{ column: dataField, expandable }}>{ text }</ConsequenceCell>
                          </td>
                        )
                      })
                    }
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    const { ConsequencesModal } = this;
    return <ConsequencesModal className="six-consequences-modal" />
  }
}



// WEBPACK FOOTER //
// ./src/views/consequences_tables/teck/six_consequences_table.js